module.exports = __webpack_public_path__ + "static/media/mt-ut-img-13.00d600f2.png";